/**
 * Product Highlight - Mobile dots pagination
 */
class ProductHighlightDots {
  constructor(section) {
    this.section = section;
    this.inner = section.querySelector('.product-highlight__inner');
    this.dotsContainer = section.querySelector('[data-dots-container]');
    this.dots = this.dotsContainer?.querySelectorAll('.product-highlight__dot');
    
    if (!this.dotsContainer || !this.inner || !this.dots?.length) return;

    this.mediaQuery = window.matchMedia('(max-width: 767.98px)');
    
    if (this.mediaQuery.matches) {
      this.init();
    }

    this.mediaQueryHandler = (e) => {
      if (e.matches) {
        this.init();
      } else {
        this.disable();
      }
    };
    this.mediaQuery.addEventListener('change', this.mediaQueryHandler);
  }

  init() {
    if (!this.inner || !this.dots) return;

    this.slides = this.inner.querySelectorAll('.product-highlight__slide');
    if (!this.slides.length) return;

    this.updateSlideWidth();
    
    this.scrollHandler = () => {
      requestAnimationFrame(() => this.updateActiveDot());
    };
    this.inner.addEventListener('scroll', this.scrollHandler, { passive: true });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToSlide(index));
    });

    this.updateActiveDot();

    this.resizeObserver = new ResizeObserver(() => {
      this.updateSlideWidth();
      this.updateActiveDot();
    });
    this.resizeObserver.observe(this.inner);
  }

  updateSlideWidth() {
    if (this.slides && this.slides.length > 0) {
      const firstSlide = this.slides[0];
      const gap = parseFloat(getComputedStyle(this.inner).gap) || 0;
      this.slideWidth = firstSlide.offsetWidth + gap;
    }
  }

  updateActiveDot() {
    if (!this.inner || !this.dots || !this.slideWidth) return;

    const scrollLeft = this.inner.scrollLeft;
    const currentIndex = Math.round(scrollLeft / this.slideWidth);
    const activeIndex = Math.min(Math.max(0, currentIndex), this.dots.length - 1);

    this.dots.forEach((dot, index) => {
      dot.classList.toggle('product-highlight__dot--active', index === activeIndex);
    });
  }

  scrollToSlide(index) {
    if (!this.inner || !this.slideWidth || index < 0 || index >= this.slides.length) return;

    const targetScrollLeft = index * this.slideWidth;
    this.inner.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });
  }

  disable() {
    if (this.inner && this.scrollHandler) {
      this.inner.removeEventListener('scroll', this.scrollHandler);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

function initProductHighlightDots() {
  document.querySelectorAll('.product-highlight').forEach((section) => {
    // Check if already initialized
    if (!section.dataset.dotsInitialized) {
      section.dataset.dotsInitialized = 'true';
      new ProductHighlightDots(section);
    }
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductHighlightDots);
} else {
  initProductHighlightDots();
}

// Handle Shopify section reloading (theme editor)
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.product-highlight');
  if (section) {
    section.dataset.dotsInitialized = 'false';
    initProductHighlightDots();
  }
});
